import { render, staticRenderFns } from "./tppwb-padel-input.vue?vue&type=template&id=34f8fbb6&"
import script from "./tppwb-padel-input.vue?vue&type=script&lang=ts&"
export * from "./tppwb-padel-input.vue?vue&type=script&lang=ts&"
import style0 from "./tppwb-padel-input.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports